import { toast } from "react-toastify";

import {
  UpdateWebhookRequestBodyType,
  WebhookDto,
} from "@intelligems/ig-types";
import { organizationsKeys } from "@src/api/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrgId } from "../organizations/get-organization";

export const usePatchWebhook = () => {
  const orgId = useGetOrgId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: UpdateWebhookRequestBodyType
    ): Promise<WebhookDto> => {
      const response = await api.patch<
        WebhookDto,
        UpdateWebhookRequestBodyType
      >(`/v2/webhooks`, data);
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.webhooks(orgId),
      });
      toast.success("Webhook updated successfully");
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Failed to update webhook");
    },
  });
};
